import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Card, CardHeader, CardBody, Badge, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import "../../../../../../custom.css";

import {
  ApiUrl,
  Axios,
  toast,
  Loading,
  moment,
} from "../../../../../../components";

const { VENUE_BOOKING_HOME } = ApiUrl;

const VenueBookingDetails = (props) => {
  const { id } = props.match.params;
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("arbitration");

  useEffect(() => {
    const fetchBookingDetails = async () => {
      try {
        const response = await Axios.get(`${VENUE_BOOKING_HOME}/${id}`);
        if (response.data.status) {
          setBooking(response.data.data);
        } else {
          toast.error(response.data.message || "Failed to fetch booking details");
        }
      } catch (error) {
        toast.error("Error fetching booking details");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchBookingDetails();
  }, [id]);

  const formatDateTime = (date, time) => {
    return moment(`${date.split("T")[0]} ${time}`).format("DD-MMMM, hh:mm A");
  };

  const formatDate = (date) => {
    return moment(date).format("DD-MMMM-YYYY, hh:mm A");
  };

  const getExtraServices = (booking) => {
    const services = [];
    if (booking.stenography) services.push("Stenography");
    if (booking.transcription) services.push("Transcription");
    if (booking.pantry_service) services.push("Pantry Service");
    if (booking.vide_conference) services.push("Video Conference");
    return services.length > 0 ? services.join(", ") : "None";
  };

  const getPreferredCommunication = (booking) => {
    const methods = [];
    if (booking.preferred_communication_whatsapp) methods.push("WhatsApp");
    if (booking.preferred_communication_email) methods.push("Email");
    if (booking.preferred_communication_sms) methods.push("SMS");
    return methods.length > 0 ? methods.join(", ") : "None";
  };

  const handleGoBack = () => {
    props.history.goBack();
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="mt-4 mr-4 mb-3">
      <section className="Sales_analytics">
        <div className="venue-admin-booking p-2">
          <Link
            to="#"
            onClick={handleGoBack}
            style={{
              color: "grey",
              fontSize: "32px",
            }}
          >
            <i className="zmdi zmdi-arrow-left" style={{ fontSize: "22px" }}></i>
          </Link>

          <h2>Venue Booking Details</h2>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <Loading />
            </div>
          ) : booking ? (
            <>
              <Card className="mt-3 venue-booking-header-card">
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="mb-0">{booking.case_name}</h4>
                    <p className="mb-0 text-muted">{booking.case_number}</p>
                  </div>
                  <Badge
                    color={booking.status ? "success" : "warning"}
                    className="venue-booking-status-badge"
                  >
                    {booking.status ? "Accepted" : "Pending"}
                  </Badge>
                </CardHeader>
              </Card>

              <Card className="mt-3 venue-tabbed-card">
                <Nav tabs className="venue-tab-nav">
                  <NavItem>
                    <NavLink
                      className={activeTab === "arbitration" ? "active" : ""}
                      onClick={() => toggleTab("arbitration")}
                    >
                      Arbitration
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "booking" ? "active" : ""}
                      onClick={() => toggleTab("booking")}
                    >
                      Booking
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "services" ? "active" : ""}
                      onClick={() => toggleTab("services")}
                    >
                      Services
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "contact" ? "active" : ""}
                      onClick={() => toggleTab("contact")}
                    >
                      Contact
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "audit" ? "active" : ""}
                      onClick={() => toggleTab("audit")}
                    >
                      Audit
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab} className="venue-tab-content">
                  <TabPane tabId="arbitration">
                    <CardBody>
                      <p className="mb-2">
                        <strong>Case Name:</strong> {booking.case_name}
                      </p>
                      <p className="mb-2">
                        <strong>Case Number:</strong> {booking.case_number}
                      </p>
                      <p className="mb-2">
                        <strong>Parties Involved:</strong> {booking.parties_involved}
                      </p>
                    </CardBody>
                  </TabPane>
                  <TabPane tabId="booking">
                    <CardBody>
                      <p className="mb-2">
                        <strong>Preferred Venue:</strong> {booking.preferred_venue}
                      </p>
                      <p className="mb-2">
                        <strong>Preferred Seat:</strong> {booking.preferred_seat}
                      </p>
                      <p className="mb-2">
                        <strong>Booking Date & Time:</strong>{" "}
                        {formatDateTime(booking.booking_date, booking.start_time)}
                      </p>
                      <p className="mb-2">
                        <strong>End Time:</strong>{" "}
                        {moment(
                          `${booking.booking_date.split("T")[0]} ${booking.end_time
                          }`
                        ).format("hh:mm A")}
                      </p>
                    </CardBody>
                  </TabPane>
                  <TabPane tabId="services">
                    <CardBody>
                      <p className="mb-2">
                        <strong>Services:</strong> {getExtraServices(booking)}
                      </p>
                    </CardBody>
                  </TabPane>
                  <TabPane tabId="contact">
                    <CardBody>
                      <p className="mb-2">
                        <strong>Full Name:</strong> {booking.contact_full_name}
                      </p>
                      <p className="mb-2">
                        <strong>Organization:</strong> {booking.contact_organization}
                      </p>
                      <p className="mb-2">
                        <strong>Contact Email:</strong> {booking.contact_email}
                      </p>
                      <p className="mb-2">
                        <strong>Alternate Email:</strong> {booking.alternate_email}
                      </p>
                      <p className="mb-2">
                        <strong>Contact Phone:</strong> {booking.contact_phone}
                      </p>
                      <p className="mb-2">
                        <strong>Alternate Phone:</strong> {booking.alternate_phone}
                      </p>
                      <p className="mb-2">
                        <strong>Preferred Communication:</strong>{" "}
                        {getPreferredCommunication(booking)}
                      </p>
                    </CardBody>
                  </TabPane>
                  <TabPane tabId="audit">
                    <CardBody>
                      <p className="mb-2">
                        <strong>Created At:</strong> {formatDate(booking.created_at)}
                      </p>
                      <p className="mb-2">
                        <strong>Updated At:</strong> {formatDate(booking.updated_at)}
                      </p>
                    </CardBody>
                  </TabPane>
                </TabContent>
              </Card>
            </>
          ) : (
            <div className="text-center mt-4">
              <p>No booking details found.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default VenueBookingDetails;